<script>
  import formatDateMixin from '@mixins/FormatDateMixin.vue'
  import {
    Edit3Icon,
  } from 'vue-feather-icons'
  import {
    documentMethods,
    userMethods,
  } from '@state/helpers'
  import {
    doesUserHavePermission,
  } from '@utils/permissions'

  export default {
    components: {
      Edit3Icon
    },
    mixins: [formatDateMixin],
    props: {
      value: {
        type: Object,
        default: () => ({})
      },
      hideColumns: {
        type: Array,
        default: () => [],
      },
      wrapperClasses: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        windowWidth: 0,
        isLoading: false,
      }
    },
    computed:{
      resolveClasses(){
        if (this.hasPermissions()){
          return 'tw-text-primary hover:tw-text-black active:tw-text-black tw-underline tw-decoration-primary hover:tw-decoration-black active:tw-decoration-black'
        }
        return 'tw-italic'
      }
    },
    mounted(){
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
    },
    methods: {
      ...documentMethods,
      ...userMethods,
      doesUserHavePermission,
      showColumn(key){
        return this.hideColumns.indexOf(key) === -1
      },
      dynamicallyHide(obj){
        if (obj && obj.innerWidth){
          if (this.windowWidth <= obj.innerWidth){
            return true
          }
        }
        return false
      },
      resolveDate(dateTime){
        try{
          return this.formatSQLTimestamp(dateTime)
        }catch (err){
          return ""
        }
      },
      tryToEdit(item){
        if (this.isLoading || !this.hasPermissions()){
          return
        }
        const params = ((['home', 'dashboard'].indexOf(this.$route.name) !== -1) || (['QU','SO','PO','IV'].indexOf(item.type) !== -1))
          ? { id: item.project_id }
          : { ...this.$route.params }
        const routerObject = this.resolveRouterObjectForDocument(item, params);
        this.isLoading = true
        return this.$router.push(routerObject)
      },
      hasPermissions(){
        return this.doesUserHavePermission( this.getUserPermissions(), this.resolveEditPermissionsForDocumentByType(this.resolveTypeForDocument(this.value.type)), this.getUserType())
      },
    },
  }
</script>

<template>
  <section
    :class="[wrapperClasses, { 'mg-r-85': !dynamicallyHide({ 'innerWidth': 1700 }), 'mg-r-40': dynamicallyHide({ 'innerWidth': 1700 }) }]">
    <a
      v-if="showColumn('name')"
      :class="['address-title text-bold curs-p  tx-col-hov-black tx-col-blue mn-w-175', { 'f-w-190 fl-left-right': dynamicallyHide({ 'innerWidth': 1400 }), 'f-w-180': !dynamicallyHide({ 'innerWidth': 1400 }), 'tx-col-gray': !hasPermissions }]"
      @click="tryToEdit(value)">
      <BaseStatusPill
        v-if="!!value.status  && dynamicallyHide({ 'innerWidth': 1400 })"
        :status="value.status.key"
        :value="value.document_name"
        :text-classes="resolveClasses"
        enable-border />
      <span v-else :class="resolveClasses">{{value.document_name}}</span>
    </a>
    <div
      v-if="showColumn('type')"
      :class="['address-title text-bold col-3 tx-truncate', { 'd-none': dynamicallyHide({ 'innerWidth': 1700 }) }, { 'tx-style-italics tx-col-gray': !hasPermissions }]">
      {{resolveTypeForDocument(value.type)}}
    </div>
    <div
      v-if="showColumn('contact')"
      :class="['address-title text-bold col-2 tx-truncate', { 'd-none': dynamicallyHide({ 'innerWidth': 1700 }) }, { 'tx-style-italics tx-col-gray': !hasPermissions }]">
      {{resolveContactForDocument(value)}}
    </div>
    <div
      v-if="showColumn('status') && !dynamicallyHide({ 'innerWidth': 1400 })"
      class="status-content col-3">
      <BaseStatusPill
        v-if="!!value.status"
        :status="value.status.key"
        :value="value.status.name"
        extra-classes="mg-l-n-20"
        enable-border />
    </div>
    <div
      v-if="showColumn('dateUpdate')"
      :class="['col-2 px-2', { 'd-none': dynamicallyHide({ 'innerWidth': 1175 }) },{ 'tx-style-italics tx-col-gray': !hasPermissions }]">
      <p class="date m-0 mg-l-n-20">{{resolveDate(value.updated_at)}}</p>
    </div>
    <div
      v-if="showColumn('total')"
      :class="[{ 'd-none': dynamicallyHide({ 'innerWidth': 950 }), 'tx-col-gray': !hasPermissions }]">
      <p class="value m-0 text-bold mg-r-20 mn-w-75">{{ resolveDocumentDenominationTotal(value) }}</p>
    </div>
    <a
      v-if="showColumn('edit') && hasPermissions()"
      class="button-action button-action-negative cl-primary fl-al-center"
      @click="tryToEdit(value)"
    >
      <Edit3Icon size="18" />
    </a>
  </section>
</template>
